import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';
import StepperContext from '../stepper-context';

const { Paragraph, Tag } = designSystem;

const StepperTitle = ({ id, title, label = '', isHidden = false }) => {
  const { activeStepId, activeTitleRef } = useContext(StepperContext);

  const isActive = id === activeStepId;

  return (
    <div
      className={classNames('ws-stepper__title', {
        'ws-stepper__title--hidden': isHidden,
      })}
      key={id}
      {...(isActive && { ref: activeTitleRef })}
    >
      <Paragraph isClipped weight="medium" {...(!isActive && { appearance: 'low-emphasis' })}>
        {title}
      </Paragraph>
      {label && isActive && <Tag label={label} appearance="accent-secondary" size="small" />}
    </div>
  );
};

StepperTitle.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  isHidden: PropTypes.bool,
};

export default StepperTitle;
